const GetAgenciesUrl = '/admin/api/agencies';
const PostAgencyUrl = '/admin/api/agencies/';
const GetAgencyUrl = (id: number) => `/admin/api/agencies/${id}`;
const PutAgencyUrl = (id: number) => `/admin/api/agencies/${id}`;
const CloseAgencyUrl = (id: number) => `/admin/api/agencies/${id}/close`;
const ReopenAgencyUrl = (id: number) => `/admin/api/agencies/${id}/reopen`;

export { GetAgenciesUrl, PostAgencyUrl, GetAgencyUrl, PutAgencyUrl, CloseAgencyUrl, ReopenAgencyUrl };
